/* eslint-disable */

import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card, Button, ButtonGroup } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import useCustomLayout from 'hooks/useCustomLayout';
import { MENU_PLACEMENT, LAYOUT, USER_ROLE } from 'constants.js';
import _ from 'lodash';
import { useSelector, connect } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import { aggiornaRaggruppamento, aggiornaAnno, aggiornaFatturati, aggiornaZona } from 'features/dashboard/dashboardSlice';
import Loading from 'components/loading/Loading';
import { Redirect } from 'react-router-dom';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

import { richiediDati, filtraDati } from './funzioni';
import GraficoPerCliente from './GraficoPerCliente';
import { setCurrentUser } from 'auth/authSlice';
import ExcelExport from 'components/export/ExcelExport';

const Dashboard = ({ dispatch }) => {
  const title = 'Dashboard';
  const description = 'Review ';

  const [hideData, setHideData] = useState(true);

  const { fatturati, zona, fatturatiRaw, anni, caricamentoInCorso, anno, raggruppamento, errore, valuta } = useSelector((state) => state.dashboard);
  const {
    currentUser: { tipoUtenza },
  } = useSelector((state) => state.auth);

  useEffect(() => {
    richiediDati();
  }, []);


  const { themeValues } = useSelector((state) => state.settings);


  const GraficoTotale = ({ showLabels = true }) => (
    <Bar
      options={{
        legend: {
          display: false,
        },
      }}
      data={{
        labels: fatturati.map((f) => (showLabels ? f.etichetta : f.etichetta.slice(0, 10))),
        datasets: [
          {
            label: 'Total',
            data: fatturati.map((f) => f.valoreTotale),
            backgroundColor: themeValues.primary,
            pointBackgroundColor: themeValues.primary,
            pointBorderColor: themeValues.primary,
            pointHoverBackgroundColor: themeValues.primary,
            pointHoverBorderColor: themeValues.primary,
            pointRadius: 3,
            pointBorderWidth: 3,
            borderRadius: themeValues.borderRadiusMd.replace('px', ''),
          },
        ],
      }}
    />
  );

  const GraficoVolumi = ({ showLabels = true }) => (
    <Bar
      options={{
        legend: {
          display: showLabels,
        },
      }}
      data={{
        labels: fatturati.map((f) => (showLabels ? f.etichetta : f.etichetta.slice(0, 10))),
        datasets: [
          {
            label: 'Volums',
            data: fatturati.map((f) => f.valoreVolumi),
            backgroundColor: themeValues.primary,
            pointBackgroundColor: themeValues.primary,
            pointBorderColor: themeValues.primary,
            pointHoverBackgroundColor: themeValues.primary,
            pointHoverBorderColor: themeValues.primary,
            pointRadius: 3,
            pointBorderWidth: 3,
            borderRadius: themeValues.borderRadiusMd.replace('px', ''),
          },
        ],
      }}
    />
  );

  if (caricamentoInCorso) {
    return (
      <>
        <HtmlHead title={title} description={description} />
        <Loading />
      </>
    );
  }

  if (errore) {
    return (
      <>
        <HtmlHead title={title} description={description} />

        {/* Messaggio: nessun dato presente */}

        <h1 className="text-danger">{errore}</h1>
      </>
    );
  }

  if (tipoUtenza === USER_ROLE.Spedizioniere) {
    return <Redirect to="/80/contratti" />;
  }
  
  if (tipoUtenza === USER_ROLE.NotaSpese) {
    return <Redirect to="/65/notaspese" />;
  }

  function _getZone() {
    return Object.keys(_.groupBy(fatturatiRaw[anno.toString()], (a) => a?.Zone));
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <Row>
        <Col>
          {/* Title Start */}
          <section className="scroll-section" id="title">
            <div className="page-title-container">
              <h1 className="mb-0 pb-0 display-4">{title}</h1>
            </div>
          </section>
          {/* Title End */}

          {/* Grafici Start */}
          <section className="scroll-section">
            <Card>
              <Card.Body>
                <Card.Title>
                  Global statistics of your customers. Currently viewing data from {'  '}
                  <select
                    onChange={(e) => {
                      dispatch(aggiornaAnno(e.target.value));
                    }}
                  >
             
 
                    {_.range(new Date().getFullYear() - 5, new Date().getFullYear() + 1).map((y) => (
                      <option key={y} value={y} selected={y === anno}>
                        {y}
                      </option>
                    ))}

                  </select>
                  <button
                    className="btn btn-secondary btn-sm ms-2"
                    onClick={() => {
                      setHideData(!hideData);
                    }}
                  >
                    {hideData ? 'Show' : 'Hide'} revenue data
                  </button>
                </Card.Title>
                <Row className="mb-4">
                  <Col>
                    {[
                      { key: 'Product', label: 'Product' },
                      { key: 'Country', label: 'Origin' },
                      { key: 'Type', label: 'Type' },
                      { key: 'Measure', label: 'Measure' },
                      { key: 'Packaging', label: 'Packaging' },
                      { key: 'DescrNatura', label: 'Category'},
                      ...([USER_ROLE.Agente, USER_ROLE.Bi].includes(tipoUtenza)
                        ? [
                          { key: 'Customer', label: 'Customer' },
                          { key: 'Zone', label: 'Zone' },
                        ]
                        : []),
                    ].map((f, i) => {
                      if (f === null) return null;
                      return (
                        <Button
                          key={`${f.label}_${i}`}
                          className="me-2"
                          variant={raggruppamento === f.key ? 'secondary' : 'primary'}
                          onClick={() => dispatch(aggiornaRaggruppamento(f.key))}
                        >
                          {f.label}
                        </Button>
                      );
                    })}
                    {raggruppamento === 'Type' && tipoUtenza === USER_ROLE.Agente && (
                      <select value={zona} onChange={(e) => dispatch(aggiornaZona(e.target.value))}>
                        <option value="all">all</option>
                        {_getZone().map((z, i) => {
                          return (
                            <option value={z} key={z}>
                              {z}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={12} lg={6} className="mb-md-4">
                    <Card border>
                      <Card.Body>
                        <Card.Title>Statistics by volume (kg)</Card.Title>
                        <GraficoVolumi showLabels={raggruppamento !== 'Customer'} />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    <Card border>
                      <Card.Body>
                        <Card.Title>Statistics by value ({valuta})</Card.Title>
                        <GraficoTotale showLabels={raggruppamento !== 'Customer'} />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                {/* Tabella attuale */}
                <Row>
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        <th scope="col">
                          {raggruppamento} {raggruppamento === 'Type' && `| Viewing data from ${zona}`}
                        </th>

                        <th scope="col">Volume (kg) {anno}</th>
                        <th scope="col">
                          Value ({valuta}) {anno}
                        </th>
                        <th scope="col">Volume (kg) {anno - 1} </th>
                        <th scope="col">
                          Value ({valuta}) {anno - 1}{' '}
                        </th>
                        <th>Comparison</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fatturati.map((e, i) => {
                        return (
                          <tr key={JSON.stringify(e)}>
                            <th scope="row">{e.etichetta}</th>
                            <td>
                              kg{' '}
                              {parseFloat(e.valoreVolumi, 10)
                                .toFixed(3)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                            </td>

                            {hideData ? (
                              <td>*Redacted*</td>
                            ) : (
                              <td>
                                {valuta}{' '}
                                {parseFloat(e.valoreTotale, 10)
                                  .toFixed(2)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              </td>
                            )}
                            <td>
                              kg.{' '}
                              {parseFloat(e.volumiAnnoPrima, 10)
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </td>

                            {hideData ? (
                              <td>*Redacted*</td>
                            ) : (
                              <td>
                                {valuta}{' '}
                                {parseFloat(e.totaleAnnoPrima, 10)
                                  .toFixed(2)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              </td>
                            )}
                            <td>
                              {parseFloat(e.volumiAnnoPrima, 10) > parseFloat(e.valoreVolumi, 10) ? (
                                <CsLineIcons icon="trend-down" size="20" className="text-danger" />
                              ) : (
                                <CsLineIcons icon="trend-up" size="20" className="text-success" />
                              )}

                              <span className="ms-2">{(((e.valoreVolumi - e.volumiAnnoPrima) / e.volumiAnnoPrima) * 100).toFixed(2)}%</span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Row>
              </Card.Body>
            </Card>
          </section>
          {/* Grafici End */}
          <section>{[USER_ROLE.Agente, USER_ROLE.Bi].includes(tipoUtenza) ? <GraficoPerCliente hideData={hideData} /> : null}</section>
        </Col>
      </Row>
    </>
  );
};

export default connect()(Dashboard);
